import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const chiave = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !chiave) throw new Error('VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY sono obbligatorie')

export const supabase = createClient(url, chiave, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
})
